<template>
    <FormStep :title="appSettings.ElNetworkModuleStep3.Title" :stepNumber=3 @toggleBody="onFormStepBodyToggle">
        <div class="electrictiy-bill-calculator__form-intro-container">
            <div class="electrictiy-bill-calculator__form-preamble" v-if="appSettings.ElNetworkModuleStep3.Ingress" v-html="appSettings.ElNetworkModuleStep3.Ingress">
            </div>
        
            <read-more v-if="appSettings.ElNetworkModuleStep3.ReadMoreText" :button-text="appSettings.ElNetworkModuleStep3.ReadMoreButtonText" element-id="read-more-step-1">
                <p v-html="appSettings.ElNetworkModuleStep3.ReadMoreText">
                </p>
            </read-more>
        </div>
    

        <div v-if="!customerTypeIsCompany"  class="electrictiy-bill-calculator__form-input-container electrictiy-bill-calculator__form-input-container--with-bottom-padding">
            <label class="electrictiy-bill-calculator__form-label" for="accomodationType">Välj din boendetyp</label>
            <div class="electrictiy-bill-calculator__select-container">
                <select name="accomodationType" v-model="accomodationType" id="accomodationType" v-on:change="updateDataBasedOnAccomodationType" required>
                    <option disabled value="">Välj boendetyp</option>
                    <option
                        v-for="anAccomodationType in accomodationTypes"
                        :value="anAccomodationType.Id"
                        :key="anAccomodationType.Id"
                    >
                        {{anAccomodationType.Name}}
                    </option>
                </select>
            </div>
        </div>

        <div v-if="customerTypeIsCompany || accomodationType !== ''" class="electrictiy-bill-calculator__form-input-container">
            <label class="electrictiy-bill-calculator__form-label" for="yearlyConsumption">Fyll i årlig förbrukning (kWh)</label>
            <input class="electrictiy-bill-calculator__number-input" type="number" id="yearlyConsumption" name="yearlyConsumption" v-model="yearlyConsumption" @input="onYearlyConsumptionInput" min="1" required="required">                   
        </div>
        
        <div v-show="yearlyConsumption !== null">
            <div class="electrictiy-bill-calculator__range-inputs-container" v-if="showRangeInputs">                
                <div v-for="i in 12" :key="i" class="electrictiy-bill-calculator__range-month-input-container">
                    <div class="electrictiy-bill-calculator__range-month">
                        <label :for="'monthlyConsumption-'+i">{{util.getMonthName(i, false)}}</label>
                    </div>
                    <div class="electrictiy-bill-calculator__range-input-container">
                        <input :id="'monthlyConsumption-'+i" type="range" :min="rangeMin" :max="rangeMax" step="1"  v-model="monthlyConsumption[i]" @input="onRangeInput(i)">
                        <span class="electrictiy-bill-calculator__range-input-high-text">Antal {{rangeUnit}}</span>
                        <div class="electrictiy-bill-calculator__range-input-number"  :ref="el => setItemRef(el, i)">{{ util.getFormatedValue(monthlyConsumption[i],0, rangeUnit)}}</div>
                    </div>
                </div>
            </div>                            
        </div>                            
    </FormStep>
</template>


<script setup>
    import FormStep from './FormStep.vue';
    import ReadMore from './ReadMore.vue';
    import InfoTooltip from './InfoTooltip.vue';
    import util from '../util'
    import { CustomerTypeEnum } from '../Enums';
    import { useWizardStore } from '../stores/WizardStore';
    import { storeToRefs } from "pinia";
    import { ref, computed, watch, onMounted, nextTick} from 'vue'

    const store = useWizardStore() 
    const { appSettings, customerType, accomodationType, monthlyConsumption, yearlyConsumption } = storeToRefs(store);
    
    const rangeUnit = 'kWh';
    const showRangeInputs = ref(true); //used for strange bug in production build
    let itemRefs = [];
    let watchYearlyChange = true;

    const accomodationTypes = computed(() => {
        return store.accomodationTypesForSelectedCustomerTypeAndFuse;
    })

    const rangeMin = computed(() => {
        let monthlyEnergyChargeData = store.monthlyEnergyChargeDataForSelectedFuse;
        return monthlyEnergyChargeData ? Math.round(monthlyEnergyChargeData.MinValue) : 0;
    })
    const rangeMax = computed(() => {
        let monthlyEnergyChargeData = store.monthlyEnergyChargeDataForSelectedFuse;
        return monthlyEnergyChargeData ? Math.round(monthlyEnergyChargeData.MaxValue) : 1000;
    })    
    const customerTypeIsCompany = computed(() => {
        return customerType.value === CustomerTypeEnum.COMPANY;
    })    

    const setNumberBoxPosition = (i) => {        
        let min = rangeMin.value;
        let max = rangeMax.value;

        //Size of the range thumb
        const thumbSize = 14;

        const leftPercent = Math.min(monthlyConsumption.value[i]/((min +max))*100, 100);
        let leftPercentPxFix = 0;
        if(leftPercent >= 50) {
            const leftPercentDiff = leftPercent - 50;
            leftPercentPxFix = (leftPercentDiff/100) * -(thumbSize);
        } else {
            const leftPercentDiff = 50 - leftPercent;
            leftPercentPxFix = (leftPercentDiff/100) * (thumbSize);
        }
        itemRefs[i-1].style.left = 'calc(' +leftPercent +'% + ' + leftPercentPxFix +'px)';
    }
    
    const setItemRef = (el, index) => {
        if (el) {                
            if(itemRefs.length >= index) {
                itemRefs[index-1] = el;
            } else {
                itemRefs.push(el)
            }
        }
    };

    const updateDataBasedOnAccomodationType = () => {
        if(accomodationType.value === '' || accomodationType.value === null) {
            return;
        }
        store.updateYearlyConsumptionBasedOnSelectedAccomodationType();
        updateDataBasedOnYearlyConsumption();
    }

    const updateDataBasedOnYearlyConsumption = () => {
        store.updateMonthlyConsumptionBasedOnYearlyConsumption();
        store.updateMonthlyPowerPeakBasedOnYearlyConsumption();
        updateNumberBoxes();
    }

    const updateNumberBoxes = () => {        
        itemRefs.forEach((itemRef, index) => {            
            setNumberBoxPosition(index+1);
        });
    }

    watch(yearlyConsumption, (newVal, oldVal) => {   
        if(watchYearlyChange) {               
            store.setYearlyConsumption(newVal);  
            updateDataBasedOnYearlyConsumption();           
        } else {
            watchYearlyChange = true;
        }
    })
    
    watch(monthlyConsumption, () => {    
        watchYearlyChange = false;
        store.setYearlyConsumptionAsSumOfMonthlyConsumtions();
     }, {deep: true})       

    const onYearlyConsumptionInput = (i) => {
        watchYearlyChange = false;
        updateDataBasedOnYearlyConsumption();
    }

    const onRangeInput = (i) => {
        watchYearlyChange = false;
        setNumberBoxPosition(i);
    }
    
    const onFormStepBodyToggle = (isOpen) => {
        showRangeInputs.value = isOpen;
        if(isOpen) {
            nextTick(() => {
                updateNumberBoxes();
            });
        }
    }

    onMounted(() => {  
        updateNumberBoxes();
    })    
    
</script>



<style scoped>

</style>
